/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ZteTableFragment = { __typename: 'ZteEnrolment', id: string, alias?: string | null, batchName?: string | null, serialNumber?: string | null, status: string, macAddress?: string | null, customerId?: string | null, customerName?: string | null, createdAt: any, assignedAt?: any | null, modelNumber?: string | null, firmwareVersion?: string | null };

export const ZteTableFragmentDoc = gql`
    fragment ZteTable on ZteEnrolment {
  id
  alias
  batchName
  serialNumber
  status
  macAddress
  customerId
  customerName
  createdAt
  assignedAt
  modelNumber
  firmwareVersion
}
    `;